export const API_BASE_URL = 'https://admin-tennis.ru/api';

export const API_ENDPOINTS = {
  login: '/login',
  getArena: (date: string) => `/arena/${date}/new`,
  getRacketTime: (date: string) => `/racket-time/${date}`,
  courts: '/courts',
  closeClayCourts: '/grunts/close',
  openClayCourts: '/grunts/open',
}; 